import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    entranceDate: Yup.date()
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .required("Angabe ist erforderlich"),
});

export const EntranceDateSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formEntranceDate">
                    <Form.Label>Frühestmöglicher Eintritt*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        type="date"
                        name="entranceDate"
                        value={values.entranceDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.entranceDate && !errors.entranceDate}
                        isInvalid={touched.entranceDate && errors.entranceDate}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.entranceDate}
                    </Form.Control.Feedback>
                </Form.Group>
          </Row>
        </>
    );
};